import { render, staticRenderFns } from "./Tagsicon.vue?vue&type=template&id=7a5af3f8&scoped=true&"
import script from "./Tagsicon.vue?vue&type=script&lang=js&"
export * from "./Tagsicon.vue?vue&type=script&lang=js&"
import style0 from "./Tagsicon.vue?vue&type=style&index=0&id=7a5af3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5af3f8",
  null
  
)

export default component.exports